import { call, put } from 'redux-saga/effects';
import * as trackTime from '../../../../services/tracking-time';
import api from '../../../../services/api';
import * as Actions from './actions';

export function* searchRequest({ protocolo, fields }) {
  try {
    const filter = {};

    for (const [key, value] of Object.entries(fields)) {
      if (value !== '') filter[key] = value;
    }

    const body = {
      filter: { ...fields },
    };

    const client = yield call(api, 'protocolo');
    const response = yield call(client.post, 'consultasql/exec/recepcionarbusca', body);

    yield put(Actions.searchSuccess(response.data));
  } catch (error) {
    yield put(Actions.requestFailure());
  }
}

export function* searchUsuarioRequest({ payload }) {
  try {
    const client = yield call(api, 'protocolo');
    const response = yield call(client.get, 'preparacao');
    yield put(Actions.searchUsuarioSuccess(response.data));
  } catch (error) {
    yield put(Actions.requestFailure());
  }
}

export function* recepcionarRequest({ payload }) {
  try {
    const client = yield call(api, 'protocolo');

    /* Validação de caixas */

    const filter_original = {
      caixa_numero: payload.caixa_originais,
      tipo_caixa: 'ORIGINAL',
    };
    const response_caixa = yield call(client.post, 'consulta/exec/caixa_pesquisar', { filter: filter_original });

    if (!response_caixa.data.length) {
      yield put(Actions.requestFailure('Caixa original não encontrada.'));
      return false;
    }

    if (payload.caixa_copias !== '') {
      const filter_copia = {
        caixa_numero: payload.caixa_copias,
        tipo_caixa: 'COPIA',
      };

      const response_caixa_copia = yield call(client.post, 'consulta/exec/caixa_pesquisar', { filter: filter_copia });
      if (!response_caixa_copia.data.length) {
        yield put(Actions.requestFailure('Caixa cópia não encontrada.'));
        return false;
      }
    }

    /* ========================== */

    const now = new Date();
    const obj = { start_date: now, end_date: now };
    const timer = trackTime.get(`recepcao-${payload.numero_protocolo}`);

    const body = { ...payload, ...{ track_time: { ...obj, ...timer } } };
    const response = yield call(client.post, '/recepcao/protocolo', body);

    yield put(Actions.recepcionarSuccess(response.data));
  } catch (error) {
    yield put(Actions.requestFailure());
  }
}
